import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  scrollToTop,
  activateLoader,
  disableLoader
} from '../../redux/actions/ui-trigger/ui-trigger-action';
import { connect } from 'react-redux';
import './paginated-list.scss';
import { checkParamInURL } from '../../utils/library';
function padArray(array, pageSize) {
  const padLength = Math.ceil(array.length / pageSize) * pageSize - array.length;
  return array.concat(Array.from({ length: padLength }, () => null));
}

class PaginatedList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 0
    };
    this.FORWARD = 'FORWARD';
    this.BACKWARD = 'BACKWARD';
  }

  onButtonClick = (MODE) => {
    return async () => {
      const {
        totalEntries,
        fetchEntries,
        scrollToTop,
        activateLoader,
        disableLoader,
        pageSize,
        searchFilter: { to, from, status, input }
      } = this.props;
      const statuses = status.length > 0 ? JSON.stringify(status) : null;
      const { page } = this.state;
      const pageNumber =
        MODE === this.FORWARD ? Math.min(totalEntries, page + 1) : Math.max(0, page - 1);

      if (pageNumber !== this.state.page) {
        activateLoader();
        await fetchEntries(null, pageSize, pageNumber * pageSize, to, from, input, statuses);
        this.setState({ page: pageNumber });
        scrollToTop();
        disableLoader();
      }
    };
  };
  setPageNumber = (itemIndex) => {
    const pageNumber = Math.floor(itemIndex / this.props.pageSize);
    this.setState({ page: pageNumber });
  };

  checkTransactionHistoryParams = (data) => {
    const transactionNumber = checkParamInURL('transaction_no');
    if (data?.length && transactionNumber) {
      const historyItemRowNumber = data.findIndex(
        (item) => item.transaction_number === transactionNumber
      );
      historyItemRowNumber !== -1 && this.setPageNumber(historyItemRowNumber);
    } else {
      this.setState({ page: 0 });
    }
  };

  UNSAFE_componentWillReceiveProps(props) {
    if (this.props.pageSize !== props.pageSize || this.props.data !== props.data) {
      if (props.isTransactionHistory && props.isIndividual)
        this.checkTransactionHistoryParams(props.data);
      else this.setState({ page: 0 });
    }
  }

  render() {
    const {
      className,
      data,
      renderHeader,
      renderItem,
      renderPagination,
      renderEmpty,
      pageSize,
      displayNote,
      isNiumForexUser,
      totalEntries
    } = this.props;

    const totalPages = Math.ceil(totalEntries / pageSize);

    return [
      <div key="list" className={className}>
        {renderHeader && renderHeader(data)}
        <div className="list">
          {!data || !data.length
            ? renderEmpty
            : padArray(data, pageSize).map((item, index) => renderItem && renderItem(item, index))}
        </div>
      </div>
    ].concat(
      renderPagination && data && data.length ? (
        <div key="pagination" className="pagination">
          {displayNote && !isNiumForexUser && (
            <div className="diplay-note">
              {`Please note:If you have initiated a bank transfer to Instarem, it might take from 24-36 business hours for the 'Awaiting
              payment' status to change.`}
            </div>
          )}
          {renderPagination(
            this.onButtonClick(this.BACKWARD),
            this.onButtonClick(this.FORWARD),
            this.state.page,
            totalPages
          )}
        </div>
      ) : (
        []
      )
    );
  }
}

PaginatedList.propTypes = {
  data: PropTypes.array,
  pageSize: PropTypes.number,
  className: PropTypes.string,
  renderHeader: PropTypes.func,
  renderItem: PropTypes.func,
  renderPagination: PropTypes.func,
  displayNote: PropTypes.bool,
  renderEmpty: PropTypes.any,
  scrollToTop: PropTypes.func,
  isTransactionHistory: PropTypes.bool,
  isIndividual: PropTypes.bool,
  isNiumForexUser: PropTypes.bool,
  totalEntries: PropTypes.number,
  activateLoader: PropTypes.func,
  disableLoader: PropTypes.func,
  fetchEntries: PropTypes.func,
  searchFilter: PropTypes.any
};

export default connect(null, {
  scrollToTop,
  activateLoader,
  disableLoader
})(PaginatedList);
